/**
 * OverviewKpiCardSkeleton - Loading state for KPI cards
 * 
 * Matches the exact layout of OverviewKpiCard with shimmer animation
 */

import React from 'react';

export function OverviewKpiCardSkeleton() {
  return (
    <div className="bg-gradient-to-br from-white to-gray-50/50 border-2 border-gray-200 rounded-2xl p-6 animate-pulse">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="w-14 h-14 bg-gray-200 rounded-xl" />
        <div className="flex flex-col gap-1 items-end">
          <div className="w-24 h-6 bg-gray-200 rounded-md" />
          <div className="w-20 h-6 bg-gray-200 rounded-md" />
        </div>
      </div>

      {/* Value */}
      <div className="mb-4">
        <div className="w-32 h-10 bg-gray-300 rounded mb-2" />
        <div className="w-24 h-4 bg-gray-200 rounded" />
      </div>

      {/* Sparkline */}
      <div className="mb-4">
        <div className="w-full h-10 bg-gray-200 rounded" />
      </div>

      {/* Comparative metric */}
      <div className="mb-4">
        <div className="w-40 h-6 bg-gray-200 rounded inline-block" />
      </div>

      {/* Breakdown section */}
      <div className="mt-4 pt-4 border-t border-gray-200">
        <div className="w-32 h-4 bg-gray-200 rounded mb-3" />
        <div className="space-y-2">
          {[1, 2].map(i => (
            <div key={i} className="flex items-center space-x-2">
              <div className="w-24 h-4 bg-gray-200 rounded" />
              <div className="flex-1 h-2 bg-gray-200 rounded-full" />
              <div className="w-20 h-4 bg-gray-200 rounded" />
            </div>
          ))}
        </div>
        <div className="mt-3 w-28 h-3 bg-gray-200 rounded" />
      </div>
    </div>
  );
}

